import {USER_SUMMARY_FIELDS} from './UserSummaryFieldsQuery';

const Queries = {
  USER_SUMMARY_FIELDS,
};

export {Queries};
